import { AuthenticationState, useAuth } from '@shared/auth';
import { useGetUserPermissionsQuery } from '@shared/graphql';
import { createContext, useMemo } from 'react';
interface PermissionContext {
  permissions: string[];
  loading: boolean;
}

const PermissionContext = createContext<PermissionContext | undefined>(undefined);

interface PermissionProviderProps {
  children: React.ReactNode;
}

function PermissionProvider(props: Readonly<PermissionProviderProps>) {
  const { authenticationState } = useAuth();
  const { children } = props;

  const { data, loading: isLoading } = useGetUserPermissionsQuery({
    fetchPolicy: 'cache-first',
    skip: authenticationState !== AuthenticationState.LOGGED_IN,
  });

  const permissions = data?.getMyProfile?.appPermissions ?? [];

  const contextValue = useMemo(() => {
    return {
      permissions,
      loading: isLoading,
    };
  }, [permissions, isLoading]);

  return <PermissionContext.Provider value={contextValue}>{children}</PermissionContext.Provider>;
}

export { PermissionContext, PermissionProvider };
